export const showSwagDistributionLinkSelector = () => false;
export const showBuildABoxLinkSelector = () => false;
export const showSwagAutomationLinkSelector = () => false;
export const showTalkToUsLinkSelector = () => false;
export const showOurStoryLinkSelector = () => false;
export const showBlogLinkSelector = () => false;
export const showWhatWeOfferLinkSelector = () => true;